import { render, staticRenderFns } from "./popularity.vue?vue&type=template&id=5de0244e&scoped=true&"
import script from "./popularity.vue?vue&type=script&lang=js&"
export * from "./popularity.vue?vue&type=script&lang=js&"
import style0 from "./popularity.vue?vue&type=style&index=0&id=5de0244e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0244e",
  null
  
)

export default component.exports